module.exports = __webpack_public_path__ + "static/media/022.b11910e9.png";